export const API_URL =
  process.env.REACT_APP_API_URL || 'https://api.amco.pt/api';
export const X_Access_Token =
  process.env.REACT_APP_X_ACCESS_TOKEN || '@amco-Token';
